import { render, staticRenderFns } from "./Denegado.vue?vue&type=template&id=5b8b354e&scoped=true"
import script from "./Denegado.vue?vue&type=script&lang=js"
export * from "./Denegado.vue?vue&type=script&lang=js"
import style0 from "./Denegado.vue?vue&type=style&index=0&id=5b8b354e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8b354e",
  null
  
)

export default component.exports